import { render, staticRenderFns } from "./ServiceArea.vue?vue&type=template&id=b5cbfca4"
import script from "./ServiceArea.vue?vue&type=script&lang=js"
export * from "./ServiceArea.vue?vue&type=script&lang=js"
import style0 from "./ServiceArea.vue?vue&type=style&index=0&id=b5cbfca4&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5cbfca4')) {
      api.createRecord('b5cbfca4', component.options)
    } else {
      api.reload('b5cbfca4', component.options)
    }
    module.hot.accept("./ServiceArea.vue?vue&type=template&id=b5cbfca4", function () {
      api.rerender('b5cbfca4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/tabs/ServiceArea.vue"
export default component.exports